import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CallOffDetailsExternalUser } from '~/modules/callOff/externalUser';

import { buildRouteExport } from '~/utils/buildRouteExport';

/**
 * Search params schema for the call-off magic link route for external users.
 */
export const zodCallOffMagicLinkSearchParamsSchema = z.object({
  token: z.string().trim().min(10),
  viewAttachmentId: z.uuid().optional().catch(undefined),
});

export const Route = createFileRoute(
  '/(custom)/external/call-offs/$callOffId/',
)({
  component: CallOffDetailsExternalUser,
  validateSearch: zodCallOffMagicLinkSearchParamsSchema,
});

export const DEMAND_CALLOFF_EXTERNAL = buildRouteExport({ Route });
